import React from "react";
import MainFacet from "../../components/MainFacet/MainFacet";
import {useDispatch, useSelector} from "react-redux";
import styles from "./MobileFiltersContainer.module.scss";
import MenuContainer from "../MenuContainer/MenuContainer";
import MobileFilterButton from "../../components/MobileFilterButton/MobileFilterButton";
import getActiveMainFacetID from "../../Utils/getActiveMainFacetID";
import ActiveFiltersContainer from "../ActiveFiltersContainer/ActiveFiltersContainer";
import {TOGGLE_MENU} from "../../Store/Actions/ActionTypes";

const MobileFiltersContainer = (props) => {
    const newFilterState = useSelector(state => state.newFilterReducer);
    const dispatch = useDispatch();
    const showMobileMenu = newFilterState.showMobileMenu;
    const activeMainFacetID = getActiveMainFacetID(newFilterState);
    const activeFilters = newFilterState.activeFilters;
    const hasActiveFilters = Object.keys(activeFilters).length > 0;

    let mainFacetsR = [];
    const facets = newFilterState.facets;

    const newOrder = [
        'utdanninger',
        'laerested',
        'yrker',
        'artikler',
        'annet_innhold'
    ];
    newOrder.map(id => {
        if (facets[id]) {
            const item = facets[id];
            mainFacetsR.push(<MainFacet key={id} id={id} value={item.value} count={item.count}/>);
        }
        return true;
    });

    const buttonClickHandler = () => {
        dispatch({type: TOGGLE_MENU});
    };

    let overview;
    const totalItems = newFilterState.totalItems;
    if (totalItems) {
        const thisPage = newFilterState.thisPage;
        const itemsPerPage = newFilterState.itemsPerPage;
        const fra = thisPage === 1 ? 1 : (thisPage - 1) * itemsPerPage + 1;
        let til = fra + itemsPerPage - 1;

        if (til > totalItems) {
            til = totalItems;
        }
        overview = `Viser ${fra}-${til} av ${totalItems}`;
    }
    else {
        overview = "Ingen treff";
    }

    if (!mainFacetsR.length) {
        const errors = newFilterState.errors;
        if (errors.hovedfasett !== undefined) {
            return <div className={styles.error}>Hovedfasett forespørsel feil</div>;
        }
    }

    return (
        <div className={styles.lightgray}>
            {/* The active filters are placed in a different position in mobile than in desktop. */}
            {hasActiveFilters &&
            <ActiveFiltersContainer />
            }

            <div className={styles.overview}>
            {overview}
            </div>

            <MobileFilterButton isActive={showMobileMenu} clickHandler={buttonClickHandler}/>

            {showMobileMenu && !activeMainFacetID &&
                <div className={styles.relative} tabIndex="0">
                    <div tabIndex="0" id="filters+" className={styles.wrapper}>
                        {mainFacetsR}
                    </div>
                </div>
            }

            {showMobileMenu && activeMainFacetID &&
                <div className={styles.relative}>
                    <div tabIndex="0" id="filters+" className={styles.wrapper}>
                        <MenuContainer/>
                    </div>
                </div>
            }
        </div>
    );

};

export default MobileFiltersContainer;
